import React, { useState } from "react";
import profileAvatar from "../../../assets/img/profile-avatar-gray.jpg";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import { useAuth } from "../../../contexts/auth";
import OperadorService from "../../../services/OperadorService";
import "./ListOperadores.css";

const ListOperadores = (props) => {
	const [operadores, setOperadores] = useState([]);
	const [maxPage, setMaxPage] = useState(1);
	const { user } = useAuth();
	const [collumnClicked, setCollumnClicked] = useState({
		collumnTitle: "createdAt",
		orderDirection: "DESC",
	});
	const [isLoading, setIsLoading] = useState(true);

	const getOperadores = async (page, searchText, clientID, collumnClicked) => {
		setIsLoading(true);
		const operatorsResponse =
			await OperadorService.listClientOperadoresPaginated(
				page,
				searchText,
				clientID,
				collumnClicked
			);
		setOperadores(operatorsResponse.data.items?.map(person => ({
			...person,
			authorityLevels: person.authorityLevels
				.filter(level => user.userData.isSuperAdmin || user.userData.person.hasRootAccess || user.userData.person.authorityLevels
					.some(levelViewer => level.unitId === levelViewer.unitId || (levelViewer.hierarchy && level.authorityPath.startsWith(levelViewer.authorityPath)))) || [],
		})));
		setMaxPage(operatorsResponse.data.pagination.totalPages);
		setIsLoading(false);
	};

	React.useEffect(() => {
		getOperadores(1, props.filters, user.userData.selectedOrganizationId, collumnClicked);
	}, [user, props.filters, collumnClicked, user.userData.selectedOrganizationId, props.refreshKey]);

	return (
		<React.Fragment>
			<div className="list-container list-visibility">
				<List
					isLoading={isLoading}
					handleCollumnTitleClick={(collumnClicked) =>
						setCollumnClicked(collumnClicked)
					}
					collumsObjIndex={[
						{ collumnLabel: "Nome", index: "name", type: "text" },
						{ collumnLabel: "CPF", index: "document", type: "text" },
						{ collumnLabel: "Telefone", index: "phone", type: "text" },
						{ collumnLabel: "Conta cloud", index: "hasUser", type: "boolean" },
					]}
					data={operadores}
				/>
			</div>
			<div className="card-visibility">
				{operadores &&
					operadores.map((operador, index) => (
						<Card
							key={index}
							data={operador}
							image={profileAvatar}
							delete={() => OperadorService.deleteOperador(operador.id)}
							navigateOnDelete={"../consulta-operadores"}
							navigateOnEdit={"../cadastro-operadores"}
						>
							<p className="card-content-title">{operador.name}</p>
							<p className="card-content">CPF: {operador.cpf}</p>
							<p className="card-content">Telefone: {operador.phone_number}</p>
							<p className="card-content">Email: {operador.mail}</p>
							<p className="card-content">Cargo: {operador.role}</p>
							<p className="card-content">Tema: {operador.theme}</p>
						</Card>
					))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) =>
					getOperadores(
						page,
						props.filters,
						user.userData.selectedOrganizationId,
						collumnClicked
					)
				}
			/>
		</React.Fragment>
	);
};

export default ListOperadores;
